<h3 class="text-xs font-semibold uppercase tracking-wide text-slate-600 mb-1">
  <i class="fa-solid fa-percent mr-1 text-violet-500"></i> v2 cost markup
</h3>
<p class="text-[11px] text-slate-500 mb-2">
  Added to the cost of every v2 project of this account before the credits are calculated (20 % = $1 is billed as $1.20).
  The customer only sees credits.
</p>
<table class="w-full text-xs mb-2">
  <thead class="text-slate-500">
    <tr><th class="text-left font-medium py-1">Cost</th><th class="text-left font-medium">Markup %</th><th class="text-right font-medium">$1 of cost → credits</th></tr>
  </thead>
  <tbody>
    <tr *ngFor="let r of rows" class="border-t border-slate-100">
      <td class="py-1 text-slate-700">{{ r.label }}</td>
      <td><input type="number" min="0" max="500" step="1" class="ceo-input w-24" [name]="r.kind" [attr.aria-label]="r.label + ' markup %'" [(ngModel)]="draft[r.kind]" /></td>
      <td class="text-right tabular-nums" *ngIf="view?.effective?.[r.price] as p">
        <span [class.text-slate-400]="p.markupPct">{{ p.baseCredits | number: '1.0-2' }}</span>
        <ng-container *ngIf="p.markupPct"> → <b class="text-slate-900">{{ p.markedCredits | number: '1.0-2' }}</b></ng-container>
      </td>
    </tr>
  </tbody>
</table>
<p *ngIf="view?.updatedBy" class="text-[11px] text-slate-500 mb-2">Last set by {{ view?.updatedBy }} on {{ view?.updatedAt | date: 'medium' }}</p>
<p *ngIf="error" class="text-xs text-red-600 mb-2">{{ error }}</p>
<app-ceo-v2-write label="Save markups" [submit]="save"></app-ceo-v2-write>
